const HEX_RE = /#[0-9a-fA-F]{6}\b/g;

const SWATCH_STYLE =
  "display:inline-block;width:14px;height:14px;margin:0 1px;" +
  "border-radius:3px;border:1px solid rgba(0,0,0,0.15);vertical-align:-2px";

function swatch(hex) {
  const el = document.createElement("span");
  el.setAttribute("style", `${SWATCH_STYLE};background-color:${hex}`);
  el.setAttribute("role", "img");
  el.setAttribute("aria-label", hex);
  return el;
}

function swatchTextNode(node) {
  const text = node.nodeValue;
  const frag = document.createDocumentFragment();
  let last = 0;
  let match;
  HEX_RE.lastIndex = 0;
  while ((match = HEX_RE.exec(text))) {
    frag.append(text.slice(last, match.index), swatch(match[0]));
    last = match.index + match[0].length;
  }
  if (last === 0) return;
  frag.append(text.slice(last));
  node.replaceWith(frag);
}

// Swatch only text nodes, never attribute values (breaking links) or code/pre
// contents (breaking copyable JSON like a chart color map).
export default function renderHexSwatches(html) {
  const container = document.createElement("div");
  container.innerHTML = html;

  const walker = document.createTreeWalker(container, NodeFilter.SHOW_TEXT, {
    acceptNode(node) {
      return node.parentElement?.closest("code, pre")
        ? NodeFilter.FILTER_REJECT
        : NodeFilter.FILTER_ACCEPT;
    },
  });

  const targets = [];
  while (walker.nextNode()) targets.push(walker.currentNode);
  targets.forEach(swatchTextNode);

  return container.innerHTML;
}
